const meta = {
  module: "application_requests",
};

export default [
  {
    path: `/application_requests`,
    redirect: "/application_requests/page/1",
  },
  {
    path: `/application_requests/page`,
    redirect: "/application_requests/page/1",
  },
  {
    path: `/application_requests/page/:page`,
    name: "application_requests",
    component: () =>
      import(
        /* webpackChunkName: "applicationRequests" */ "@/modules/applicationRequests/views/index.vue"
      ),
    meta: {
      ...meta,
    },
  },
  {
    path: `/application_requests/preview/:id`,
    name: "application_requests/preview",
    component: () =>
      import(
        /* webpackChunkName: "applicationRequests/edit" */ "@/modules/applicationRequests/views/preview.vue"
      ),
    meta: {
      ...meta,
      action: "preview",
    },
  },

  {
    path: `/application_requests/enroll/:id`,
    name: "application_requests/enroll",
    component: () =>
      import(
        /* webpackChunkName: "applicationRequests/edit" */ "@/modules/applicationRequests/views/enroll.vue"
      ),
    meta: {
      ...meta,
    },
  },
];
